<template>
  <div>
    <div
      class="
      mx-auto
      row
      documents-container
      jumbo
      mt-3
      p-3
      bg-light
      d-flex
      align-items-center
    "
    >
      <div
        v-if="proposalDocuments.length"
        style="position: absolute;z-index: 1;"
        @click="expanded = !expanded"
      >
        <em
          :class="
            expanded
              ? 'far fa-chevron-circle-down color-green'
              : 'far fa-chevron-circle-right color-red'
          "
        />
      </div>
      <div class="col-4 row mx-auto">
        <label class="font-14 color-gray-6 col-12">Documento:</label>
        <label class="font-16 color-black col-12">
          {{ item.documentTypeName | empty }}
        </label>
      </div>
      <div class="col-3 row mx-auto">
        <div v-if="item.documentFilename">
          <label class="font-14 color-gray-6 col-12">Archivo:</label>
          <label class="font-16 color-black col-12">
            {{ item.documentFilename | empty }}
          </label>
        </div>
      </div>
      <div class="col row mx-auto justify-content-end">
        <div
          v-if="item.documentTypeId === documentTypes.PaymentCertificate"
          class="row col-12 row payment-upload justify-content-end"
        >
          <div
            v-if="!item.documentFilename"
            class="row col-12 justify-content-end"
          >
            <custom-file-input
              id="paymentFileUpload"
              ref="paymentFileUpload"
              v-model="paymentfile"
              accept=".pdf"
              class="custom-document-input col"
              display-style="normal"
              :on-download="() => {}"
              @input="uploadDocument(item.documentTypeId)"
            />
          </div>
          <div v-else class="row mx-auto col-12 justify-content-end">
            <action-button
              i="fas fa-download"
              text="Descargar"
              variant="success download-btn px-3"
              @click="onDownload(item.documentId)"
            />
            <action-button
              i="fas fa-undo-alt"
              text="Reemplazar"
              variant="outline-success download-btn ml-3"
              @click="onReplaceDocument(item.documentTypeId)"
            />
            <input
              v-show="false"
              id="paymentFileUploadHidden"
              ref="paymentFileUploadHidden"
              accept=".pdf"
              :attachment-id="item.documentId"
              type="file"
              @change="updateFileChange($event, item.documentTypeId)"
            />
          </div>
        </div>
        <div
          v-if="item.documentTypeId === documentTypes.EvidencePaymentReceipt"
          class="col-12 row evidence-upload d-flex justify-content-end"
        >
          <div
            v-if="!item.documentFilename"
            class="row col-12 d-flex justify-content-end"
          >
            <custom-file-input
              id="evidenceFileUpload"
              ref="evidenceFileUpload"
              v-model="evidencefile"
              accept=".pdf"
              class="custom-document-input col"
              display-style="normal"
              :on-download="() => {}"
              @input="uploadDocument(item.documentTypeId)"
            />
          </div>
          <div v-else class="row mx-auto col-12 justify-content-end">
            <action-button
              i="fas fa-download"
              text="Descargar"
              variant="success download-btn px-3"
              @click="onDownload(item.documentId)"
            />
            <action-button
              i="fas fa-undo-alt"
              text="Reemplazar"
              variant="outline-success download-btn ml-3"
              @click="onReplaceDocument(item.documentTypeId)"
            />
            <input
              v-show="false"
              id="evidenceFileUploadHidden"
              ref="evidenceFileUploadHidden"
              accept=".pdf"
              type="file"
              @change="updateFileChange($event, item.documentTypeId)"
            />
          </div>
        </div>
        <div
          v-if="item.documentTypeId === documentTypes.CertificacionVisita"
          class="col-12 row d-flex justify-content-end"
        >
          <div
            v-if="!item.documentFilename"
            class="row col-12 d-flex justify-content-end"
          >
            <custom-file-input
              id="visitCertification"
              ref="visitCertification"
              v-model="visitCertificationFile"
              accept=".pdf"
              class="custom-document-input col"
              display-style="normal"
              :on-download="() => {}"
              @input="uploadDocument(item.documentTypeId)"
            />
          </div>
          <div v-else class="row mx-auto col-12 justify-content-end">
            <action-button
              i="fas fa-download"
              text="Descargar"
              variant="success download-btn px-3"
              @click="onDownload(item.documentId)"
            />
            <action-button
              i="fas fa-undo-alt"
              text="Reemplazar"
              variant="outline-success download-btn ml-3"
              @click="onReplaceDocument(item.documentTypeId)"
            />
            <input
              v-show="false"
              id="visitCertification"
              ref="visitCertification"
              accept=".pdf"
              type="file"
              @change="updateFileChange($event, item.documentTypeId)"
            />
          </div>
        </div>
        <div
          v-if="item.documentTypeId === documentTypes.Other"
          class="col-12 row d-flex justify-content-end"
        >
          <div
            v-if="!item.documentFilename"
            class="row col-12 d-flex justify-content-end"
          >
            <custom-file-input
              id="otherFileUpload"
              ref="otherFileUpload"
              v-model="otherfile"
              accept=".pdf"
              class="custom-document-input col"
              display-style="normal"
              :on-download="() => {}"
              @input="uploadDocument(item.documentTypeId)"
            />
          </div>
          <div v-else class="row mx-auto col-12 justify-content-end">
            <action-button
              i="fas fa-download"
              text="Descargar"
              variant="success download-btn px-3"
              @click="onDownload(item.documentId)"
            />
            <action-button
              i="fas fa-undo-alt"
              text="Reemplazar"
              variant="outline-success download-btn ml-3"
              @click="onReplaceDocument(item.documentTypeId)"
            />
            <input
              v-show="false"
              id="otherFileUploadHidden"
              ref="otherFileUploadHidden"
              accept=".pdf"
              type="file"
              @change="updateFileChange($event, item.documentTypeId)"
            />
          </div>
        </div>
        <div
          v-else-if="item.documentFilename && item.requestDocumentId === 0"
          class="col-12 row d-flex justify-content-end"
        >
          <div class="row mx-auto col-12 justify-content-end">
            <action-button
              class="d-flex justify-content-center align-items-center"
              i="fas fa-download p-1"
              variant="success"
              @click="onDownload(item.documentId)"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-if="expanded" id="previous-proposal-document-container">
      <div v-for="subdoc in proposalDocuments" :key="subdoc.documentId">
        <div class="row previous-proposal-item">
          <div class="col">
            <div>
              <span class="font-14 color-gray-6 col-12">Archivo:</span>
            </div>
            <span class="font-16 color-black col-12">
              {{ subdoc.documentFilename | empty }}
            </span>
          </div>

          <div class="col-2 mt-2 justify-content-end">
            <action-button
              i="fas fa-download"
              text=""
              variant="success download-btn px-3"
              @click="onDownload(subdoc.documentId)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomFileInput from 'CustomFileInput';
import ActionButton from 'ActionButton';
import DocumentTypes from '@/utils/constants/documentTypes';
import { uploadOrUpdateFile as _uploadOrUpdateFile } from '@/modules/reinbursement/api';
import documentService from '@/modules/app/api';
import { serialize as objectToFormData } from 'object-to-formdata';
import alertMixin from '@/mixins/alert.mixin';
import storeMixin from '@quisit/mipe-utils/mixins/storeGenerator';

export default {
  name: 'ReinbursementDocuments',
  components: {
    CustomFileInput,
    ActionButton,
  },
  mixins: [alertMixin, storeMixin],
  props: {
    requestId: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
      default: () => {},
    },
    autoUpload: {
      type: Boolean,
      required: true,
      default: true,
    },
    proposalDocuments: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      paymentfile: null,
      evidencefile: null,
      visitCertificationFile: null,
      otherfile: null,
      expanded: false,
    };
  },
  computed: {
    documentTypes() {
      return DocumentTypes;
    },
  },
  methods: {
    async onDownload(documentId) {
      await documentService.downloadDocument(documentId);
    },
    async uploadDocument(documentTypeId) {
      let documentUpdated = {
        requestId: this.requestId,
        documentTypeId,
        file: null,
      };
      switch (documentTypeId) {
        case this.documentTypes.PaymentCertificate:
          documentUpdated.file = this.paymentfile;
          break;
        case this.documentTypes.EvidencePaymentReceipt:
          documentUpdated.file = this.evidencefile;
          break;
        case this.documentTypes.Other:
          documentUpdated.file = this.otherfile;
          break;
        case this.documentTypes.CertificacionVisita:
          documentUpdated.file = this.visitCertificationFile;
          break;
      }
      if (!documentUpdated.file) return;

      if (this.autoUpload) {
        let payload = objectToFormData(documentUpdated, {
          indices: true,
          nullsAsUndefineds: true,
        });
        await _uploadOrUpdateFile(payload).then(({ data }) => {
          if (data) {
            this.$emit('on-refresh-data', data);
          }
        });
      } else {
        this.$emit('on-refresh-data', documentUpdated);
      }
    },
    onReplaceDocument(documentTypeId) {
      switch (documentTypeId) {
        case this.documentTypes.PaymentCertificate:
          document.getElementById('paymentFileUploadHidden').click();
          break;
        case this.documentTypes.EvidencePaymentReceipt:
          document.getElementById('evidenceFileUploadHidden').click();
          break;
        case this.documentTypes.Other:
          document.getElementById('otherFileUploadHidden').click();
          break;
        case this.documentTypes.CertificacionVisita:
          document.getElementById('visitCertification').click();
          break;
      }
    },
    async updateFileChange(e, documentTypeId) {
      if (e.target.files && e.target.files.length > 0) {
        const selectedFile = Array.from(e.target.files)?.map((file) => file);
        let payload = objectToFormData(
          {
            requestId: this.requestId,
            documentTypeId,
            file: selectedFile[0],
          },
          { indices: true, nullsAsUndefineds: true }
        );
        await _uploadOrUpdateFile(payload).then(({ data }) => {
          if (data) {
            this.ShowToast(
              '',
              'El documento ha sido reemplazado exitosamente.',
              'success'
            );
            this.$emit('on-refresh-data', data);
          }
        });
      }
    },
  },
};
</script>

<style>
#previous-proposal-document-container {
  background: #f7f6f6;
  padding: 10px 0 15px 46px;
}

#previous-proposal-document-container .previous-proposal-item {
  margin-bottom: 15px;
}
</style>
